import { CSSProperties } from "react";
import "./OurDevelopmentProcessSection.css";
import {
  OurCoreValuesItemType,
  OurDevelopmentProcessItemTypes,
  OurDevelopmentProcessSectionType,
} from "../../../utility/types/generaTypes";

type OurDevelopmentProcessSectionProps = {
  style?: CSSProperties;
  ourDevelopmentProcessSection: OurDevelopmentProcessSectionType;
};

const OurDevelopmentProcessSection = ({
  style,
  ourDevelopmentProcessSection,
}: OurDevelopmentProcessSectionProps) => {
  return (
    <section style={style}>
      <div className="app_section">
        <div className="appSection_header_container">
          <h1 className="section_title">
            {ourDevelopmentProcessSection.title}
          </h1>
          <p className="section_description">
            {ourDevelopmentProcessSection.description}
          </p>
        </div>

        <div className="ourDevelopmentProcessCards_container">
          {ourDevelopmentProcessSection.data.map(
            (ourDevelopmentProcess, index) => (
              <OurDevelopmentProcessCard
                key={"OurDevelopmentProcessCard" + index}
                ourDevelopmentProcess={ourDevelopmentProcess}
                index={index}
              />
            )
          )}
        </div>
      </div>
    </section>
  );
};

type TechnologyWeUseCardProps = {
  ourDevelopmentProcess: OurDevelopmentProcessItemTypes;
  index: number;
};

const OurDevelopmentProcessCard = ({
  ourDevelopmentProcess,
  index,
}: TechnologyWeUseCardProps) => {
  return (
    <div className="ourDevelopmentProcessCard">
      <div className="developmentProcessStepContainer gradient_bg">
        <p>{ourDevelopmentProcess?.step}</p>
      </div>
      <h2>{ourDevelopmentProcess?.title}</h2>
      <p>{ourDevelopmentProcess?.description}</p>
    </div>
  );
};

export default OurDevelopmentProcessSection;
